// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hqJH","select":"styles_select__3IDrf"};